import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { transfer as transferInventory } from "MODULES/inventories/actions";
import {
  form,
  Form as AppForm,
  Select,
  FormInput,
  TextArea
} from "MODULES/shared/components/Forms";
import { TRANSFER_TO_LOCATION_ID } from "MODULES/inventories/constants";
import { Warning } from "MODULES/shared/components";
import { OUTGOING_AWB_NUMBER } from "MODULES/Shipping/constants";
import { SPECIAL_INSTRUCTIONS } from "MODULES/SalesOrders/constants";
import { Col } from "react-bootstrap";
import FormRow from "MODULES/shared/components/Forms/FormRow";

const formName = "transferInventory";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={12}>
            <Field
              name={TRANSFER_TO_LOCATION_ID}
              component={Select}
              label="Transfer To Location"
              options={props.locations}
              prompt={false}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={12}>
            <Field
              name={OUTGOING_AWB_NUMBER}
              label="Outgoing AWB #"
              component={FormInput}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={12}>
            <Field
              name={SPECIAL_INSTRUCTIONS}
              component={TextArea}
              label="Special Instructions (For shipping team)"
              rows="5"
              cols="50"
            />
          </Col>
        </FormRow>
        <Warning>Warning: Entering AWB # will automatically ship item.</Warning>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  locations: PropTypes.arrayOf({})
};

export default connect(undefined, dispatch => ({
  onSubmit: data =>
    dispatch(
      transferInventory(
        data.id,
        data.transfer_to_location_id,
        data.outgoing_awb_number,
        data.special_instructions
      )
    )
}))(
  form({
    form: formName
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/Transfer/Form.jsx